module.exports = __webpack_public_path__ + "img/service-hospital.adccb5b9.jpg";